module.exports = __webpack_public_path__ + "img/slogn.4138ba26.png";